module.exports = __webpack_public_path__ + "static/media/room-mgmt.eb0a5223.svg";